<template>
    <ul class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
      <li class="nav-item">
        <router-link :to="PrincipalLink" class="nav-link text-white" active-class="active">Principal</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="puntosVentasLink" class="nav-link text-white" active-class="active">Puntos de venta</router-link>
      </li>
      <v-guard :permissions="['CONFIGURACION_PROMOCIONES']">
        <!-- <li class="nav-item"><router-link :to="promocionesLink" class="nav-link text-white" active-class="active">Promociones</router-link></li> -->
      </v-guard>
      <li class="nav-item">
        <router-link :to="usuariosSistemaLink" class="nav-link text-white" active-class="active">Usuarios del sistema</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="rolesPermisosLink" class="nav-link text-white" active-class="active">Roles y permisos</router-link>
      </li>
      <v-guard :permissions="['ECOMMERCE']">
        <li class="nav-item">
          <router-link :to="ecommerceLink" class="nav-link text-white" active-class="active">E-commerce</router-link>
        </li>
      </v-guard>
      <li class="nav-item">
        <router-link :to="generalLink" class="nav-link text-white" active-class="active">General</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="tarjetasLink" class="nav-link text-white" active-class="active">Tarjetas</router-link>
      </li>
      <!-- <BranchofficeSelect v-if="getHasPermission" /> -->
    </ul>

  </template>
  
  <script>
  // import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";
  export default {
   /*  components: {
      // BranchofficeSelect
    },
    data : function () { 
      return {
        hasPermission : false
      }
    }, */
    computed: {
      /* getHasPermission() {
          return this.hasPermission
      }, */
      PrincipalLink() {
        return { name: 'Principal' }
      },
      puntosVentasLink() {
        return { name: 'Puntos de venta' }
      },
      promocionesLink() {
        return { name: 'Promociones' }
      },
      usuariosSistemaLink() {
        return { name: 'Usuarios del sistema' }
      },
      rolesPermisosLink() {
        return { name: 'Roles y permisos' }
      },
      ecommerceLink() {
        return { name: 'E-commerce' }
      },
      generalLink() {
        return { name: 'General' }
      },
      tarjetasLink() {
        return { name: 'Tarjetas' }
      },
    },
    /*  methods: {
      getAllBranchofficesFundsPermission() {
        this.$http
          .get("/api/configs/role/permissions/names", {
            headers: { 
              Authorization: "Bearer " + localStorage.getItem("token")
            },
          })
          .then((response) => {
            this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_FUNDS');
          })
      },
    },
    created() {
      this.getAllBranchofficesFundsPermission();
    }, */
  }
  </script>
  
  <style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
  /* justify-content-start fijo (no solo mientras carga el selector de
     sucursal) para que no haya salto de layout al montar/desmontar. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>